// extracted by mini-css-extract-plugin
module.exports = {"Stepper":"📚4-7-05T8-x","Quantity":"📚4-7-03WpLq","Icon":"📚4-7-02x3qQ"};